import { Product } from './product';
import { Utils } from '../helpers/utils';
import { PoptionalSelection } from './poptional-selection';

export class ProductOrder {
  id: number;


  // changeable values
  product_id: number;
  order_id: number;
  note_ids: Array<number>;
  notes_attributes: Array<any>;
  quantity: number;
  custom_price: string;
  payed: number;
  status: string;
  deletion_reason: string;
  info_was: string;
  user_name: string;

  poptional_selections: PoptionalSelection[];
  product: Product;
  notes: string;

  // timestamps
  created_at: string;
  updated_at: string;

  // data sent by our server to help us
  un_price: string;

  // set by our front-end app
  poptionals_price: number;
  get_price: string; // qty * custom_price or qty * (product's price + poptionals)
  prettyQuantity: string;
  prettyPrice: string;
  prettyUnitaryPrice: string;
  timeSince: string;
  possibilities: Product[];
  selected: boolean;
  notes_obj: {text: string}[];

  static setArrayAdditionalData(pos: ProductOrder[]) {
    for(let po of pos) {
      ProductOrder.setAdditionalData(po);
    }
  }
  static setAdditionalData(po: ProductOrder) {
    let prettyq = String(po.quantity);
    if(parseInt(prettyq) == po.quantity) { // quantity is integer
      prettyq = String(parseInt(prettyq)); // remove unnecessary zeroes
    }
    po.prettyQuantity = prettyq.replace('.',',');

    Product.setAdditionalData(po.product);
    po.poptional_selections = PoptionalSelection.fromJsonArray(po.poptional_selections || []);
    po.poptionals_price = PoptionalSelection.sumValues(po.poptional_selections);
    const unit = (po.custom_price != null && po.custom_price !== '')
      ? Number(po.custom_price)
      : Number(po.product.price);
    po.prettyUnitaryPrice = unit.toFixed(2);
    po.get_price = ((po.quantity * unit) + po.poptionals_price).toFixed(2);
    
    po.prettyPrice = po.get_price.replace('.',',');
    po.timeSince = Utils.timeSince(po.created_at, new Date());

    if(po.notes_obj) {
      po.notes = '';
      for(let note of po.notes_obj) {
        po.notes += note.text + ';';
      }
      po.notes = po.notes.substring(0, po.notes.length - 1); // remove last separator ';'
    } else if(po.notes) {
      po.notes_obj = [];
      for(let note of po.notes.split(';')) {
        po.notes_obj.push({text: note});
      }
    }
  }
}